import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-social-pinterest-1',
  standalone: true,
  templateUrl: '../../assets/social/pinterest-1.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamSocialPinterest1Icon {}
